import axios from 'axios'
import api from './api'

export interface ApiReturnType {
  data: any
  error: Error | null
}

export const apiPost = (url: string) => async (data?: any) => {
  try {
    const response = await api.post(url, data)
    return {
      data: response.data,
      error: null,
    }
  } catch (error) {
    return {
      data: null,
      error: error as Error,
    }
  }
}

export const userApiPost = (action: string) => async (data?: any) => {
  try {
    const response = await api.post('/user', { ...data, action })
    return {
      data: response.data,
      error: null,
    }
  } catch (error) {
    return {
      data: null,
      error: error as Error,
    }
  }
}

export const generalApiPost = (action: string) => async (data?: any) => {
  try {
    const response = await api.post('/general', { ...data, action })
    return {
      data: response.data,
      error: null,
    }
  } catch (error) {
    return {
      data: null,
      error: error as Error,
    }
  }
}

export const adminApiPost = (action: string) => async (data?: any) => {
  try {
    const response = await api.post('/admin', { ...data, action })
    return {
      data: response.data,
      error: null,
    }
  } catch (error) {
    return {
      data: null,
      error: error as Error,
    }
  }
}

export const fakeApiPost = (url: string, fakeData: any) => async (data?: any) => {
  console.log({ data })
  return fakeData
}

export const apiUpload = (url: string, file: File) =>
  axios.put(url, file, {
    headers: {
      'x-ms-blob-type': 'BlockBlob',
      'Content-Type': file.type,
    },
  })
